import styled from 'styled-components';

import { Headline, Text } from '../../components';

export const StyledShadowContainer = styled.div`
  box-shadow: 0 0 12px 2px rgba(0, 0, 0, 0.5);
  background-color: rgb(50, 55, 62, 0.5);
`;

export const StyledContainer = styled.div`
  display: flex;
  padding: 40px 0 32px;

  ul {
    flex-grow: 1;
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  video {
    width: 100%;
    height: 100%;
  }
`;

export const StyledHeadline = styled(Headline)`
  font-weight: 700;
`;

export const StyledMainDescription = styled(Text)`
  margin-bottom: 8px;
`;
